import { createFileRoute } from '@tanstack/react-router';

import { ValidationIssuesTab } from '../../components';

const PlansTab = () => (
  <ValidationIssuesTab
    issueCodes={[
      'noInvestmentVehicle',
      'noFunds',
      'missingMatchTier',
      'orphanedInvestmentVehicle',
      'planMissingMetadata',
      'pathMissingVehicle',
      'pathMissingFund'
    ]}
  />
);

export const Route = createFileRoute('/relationship-health/plans')({
  component: PlansTab
});
